import styled from 'styled-components';
import { colors, fontSize, fontWeight } from '../../../theme';
import { ButtonStyled } from '../../../theme/style';
import { ReactComponent as ComparisonImage } from '../../../assets/filters/comparison.svg';

export const ComparisonImageStyled = styled(ComparisonImage)`
    && {
        width: 20px;
        min-width: 20px;
        margin-right: 5px;
    }
`;

const CompareToGlobalButtonStyled = styled(ButtonStyled)(({ $isActive }: { $isActive: boolean }) => `
&& {
    height: 54px;
    padding: 0 16px;
    white-space: nowrap;
    color: ${colors.default};
    font-size: ${fontSize.sm};
    font-weight: ${$isActive ? fontWeight.semiBold : fontWeight.regular};
    background-color: ${$isActive ? colors.defaultRGBA : colors.grey000};
    /* MUI pulls the start icon 4px to the left to compensate its own padding,
       which is not wanted here. */
    & .MuiButton-startIcon {
        margin-left: 0;
    }
    &:hover {
        background-color: ${colors.defaultRGBA};
    }
    @media print {
        display: none;
    }
}
`);

export default CompareToGlobalButtonStyled;
